import React from 'react';
import styles from './HelpSectionTabs.module.scss';
import {SERVICES} from '.';
import {isEqual, keys} from 'lodash';
import {Button} from 'reactstrap';
import cx from 'classnames';
import MuiIcon from 'components/Icons/MuiIcon';

function HelpSectionTabs({tab, toggle}) {
  return (
    <div className={styles['tabs']}>
      {keys(SERVICES).map((key) => {
        const {icon, title, color} = SERVICES[key];
        const isSelected = isEqual(tab, key);

        return (
          <Button
            key={key}
            className={cx(styles[`tabs--button-${color}`], {
              [styles[`tabs--button-${color}--selected`]]: isSelected,
            })}
            onClick={() => toggle(key)}
          >
            {!!icon && <MuiIcon name={icon} />}
            <span>{title}</span>
          </Button>
        );
      })}
    </div>
  );
}

export default HelpSectionTabs;
